import { useEffect } from 'react';
import { NanoCheckoutOfferUsedStage, trackNanoCheckoutOfferUsed } from '../../../lib/analytics/events';
import { Links } from '../../../lib/constants';
import styles from './CheckoutStep.module.scss';

export interface GwaOfferUsedNoticeProps {
  petName: string;
  petId: string;
  stage: NanoCheckoutOfferUsedStage;
  /** takes the shopper to the shop at the regular price, without the adoption offer */
  onContinue: () => void;
}

/**
 * Stands in for the checkout form when this email has already used the adoption offer. It replaces the
 * form rather than sitting over it, as the purchase confirmation does: with the form still there, the
 * only thing the shopper could do is confirm a purchase web has already said it will reject.
 */
export default function GwaOfferUsedNotice({ petName, petId, stage, onContinue }: GwaOfferUsedNoticeProps) {
  useEffect(() => {
    trackNanoCheckoutOfferUsed({ petId, gwa: true }, stage);
  }, [petId, stage]);

  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <div className={styles.eyebrow}>For {petName}</div>
        <h1 className={styles.title}>You’ve already used the adoption offer.</h1>
        <p className={styles.subtitle}>
          The adoption offer can be redeemed once per email address, and this email has already claimed it. You can
          still get the Fi Mini tracker for {petName} at the regular price.
        </p>

        <div className={styles.ctaContainer}>
          <button className={styles.ctaPrimary} type="button" onClick={onContinue}>
            Continue to checkout
          </button>
          <a className={styles.ctaGhost} href={Links.manageHome}>
            Not now
          </a>
        </div>
      </div>
    </div>
  );
}
